(function () {
  if (!window.EgPdpGardenerVideos) {
    window.EgPdpGardenerVideos = {
      init(root) {
        const scopeRoot = root instanceof Element ? root : document;
        const sections = scopeRoot.querySelectorAll('[data-eg-pdp-gardener-videos]:not([data-gardener-videos-ready="true"])');

        sections.forEach((section) => {
          const track = section.querySelector('[data-gardener-videos-track]');
          const prevButtons = Array.from(section.querySelectorAll('[data-gardener-videos-prev]'));
          const nextButtons = Array.from(section.querySelectorAll('[data-gardener-videos-next]'));
          const modal = section.querySelector('[data-gardener-videos-modal]');
          const stage = section.querySelector('[data-gardener-videos-stage]');
          const modalPrev = section.querySelector('[data-gardener-videos-modal-prev]');
          const modalNext = section.querySelector('[data-gardener-videos-modal-next]');
          const closeButton = section.querySelector('[data-gardener-videos-close-button]');
          const overlay = section.querySelector('[data-gardener-videos-close]');
          const triggers = Array.from(section.querySelectorAll('[data-gardener-video-trigger]'));
          const templates = new Map(
            Array.from(section.querySelectorAll('template[data-gardener-video-template]')).map((template) => [
              Number(template.dataset.gardenerVideoTemplate),
              template
            ])
          );

          if (!track) {
            section.dataset.gardenerVideosReady = 'true';
            return;
          }

          section.dataset.gardenerVideosReady = 'true';

          const originalCards = Array.from(track.querySelectorAll('.eg-pdp-gardener-videos__card'));
          const infiniteEnabled = originalCards.length > 1;
          const previousClones = [];
          const nextClones = [];

          function createLoopClone(card, setName) {
            const clone = card.cloneNode(true);

            clone.removeAttribute('id');
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('data-gardener-video-clone', setName);
            clone.setAttribute('aria-hidden', 'true');

            clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
            clone.querySelectorAll('template').forEach((element) => element.remove());
            clone.querySelectorAll('.eg-pdp-gardener-videos__preview-video').forEach((video) => {
              video.preload = 'none';
              video.removeAttribute('autoplay');
            });
            clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
              element.setAttribute('tabindex', '-1');
            });

            return clone;
          }

          if (infiniteEnabled) {
            originalCards.forEach((card) => {
              previousClones.push(createLoopClone(card, 'previous'));
              nextClones.push(createLoopClone(card, 'next'));
            });
            track.prepend(...previousClones);
            track.append(...nextClones);
          }

          section.dataset.gardenerVideosInfinite = infiniteEnabled ? 'true' : 'false';

          if (modal && modal.parentElement !== document.body) {
            document.body.appendChild(modal);
          }

          const controller = new AbortController();
          const signal = controller.signal;
          const resizeObserver = 'ResizeObserver' in window
            ? new ResizeObserver(() => {
                updateLoopMetrics();
                scheduleLoopNormalization();
                updateControls();
              })
            : null;

          section.__egGardenerVideosController = controller;
          section.__egGardenerVideosModal = modal;

          const playableTriggers = triggers
            .filter((trigger) => !trigger.disabled && trigger.dataset.videoIndex !== undefined)
            .sort((left, right) => Number(left.dataset.videoIndex) - Number(right.dataset.videoIndex));

          let modalIndex = -1;
          let lastFocus = null;
          let closeTimer = null;
          let dragPointerId = null;
          let dragStartX = 0;
          let dragStartScrollLeft = 0;
          let dragLastTime = 0;
          let dragVelocity = 0;
          let dragMoved = false;
          let suppressClickUntil = 0;
          let scrollAnimationFrame = null;
          let loopStart = 0;
          let loopWidth = 0;
          let loopReady = false;
          let loopNormalizeTimer = null;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
          const saveData = Boolean(navigator.connection && navigator.connection.saveData);
          const hoverTimers = new WeakMap();
          const previewTriggers = Array.from(track.querySelectorAll('[data-gardener-video-trigger]'));
          const previewVideos = Array.from(section.querySelectorAll('.eg-pdp-gardener-videos__preview-video'));

          function clearHoverTimer(trigger) {
            const timer = hoverTimers.get(trigger);
            if (timer) {
              window.clearTimeout(timer);
              hoverTimers.delete(trigger);
            }
          }

          function stopPreview(trigger, reset = true) {
            clearHoverTimer(trigger);
            const video = trigger.querySelector('.eg-pdp-gardener-videos__preview-video');
            trigger.classList.remove('is-previewing');

            if (!video) return;
            video.pause();
            if (reset && video.readyState > 0) {
              video.currentTime = 0;
            }
          }

          function startPreview(trigger) {
            const video = trigger.querySelector('.eg-pdp-gardener-videos__preview-video');
            if (!video || reduceMotion.matches || !finePointer.matches || saveData) return;

            clearHoverTimer(trigger);
            const timer = window.setTimeout(() => {
              hoverTimers.delete(trigger);
              if (!trigger.matches(':hover')) return;

              trigger.classList.add('is-previewing');
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => trigger.classList.remove('is-previewing'));
              }
            }, 150);

            hoverTimers.set(trigger, timer);
          }

          function getScrollStep() {
            const firstCard = track.querySelector('.eg-pdp-gardener-videos__card');
            if (!firstCard) {
              return track.clientWidth * 0.8;
            }

            const trackStyles = window.getComputedStyle(track);
            const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
            return firstCard.getBoundingClientRect().width + gap;
          }

          function clampScroll(value) {
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
            return Math.max(0, Math.min(maxScroll, value));
          }

          function updateLoopMetrics() {
            if (!infiniteEnabled) return;

            const firstOriginal = originalCards[0];
            const firstNext = nextClones[0];
            const trackBounds = track.getBoundingClientRect();
            const originalBounds = firstOriginal.getBoundingClientRect();
            const nextBounds = firstNext.getBoundingClientRect();

            loopStart = originalBounds.left - trackBounds.left + track.scrollLeft;
            loopWidth = nextBounds.left - originalBounds.left;
            loopReady = loopWidth > 1;
          }

          function initializeLoop() {
            updateLoopMetrics();
            if (!loopReady) return;

            track.classList.add('is-loop-jumping');
            track.scrollLeft = loopStart;
            window.requestAnimationFrame(() => {
              track.classList.remove('is-loop-jumping');
            });
          }

          function normalizeLoopPosition() {
            if (!loopReady || dragPointerId !== null || scrollAnimationFrame !== null) return false;

            const lowerBoundary = loopStart - 1;
            const upperBoundary = loopStart + loopWidth - 1;
            let adjustment = 0;

            if (track.scrollLeft < lowerBoundary) {
              adjustment = loopWidth;
            } else if (track.scrollLeft >= upperBoundary) {
              adjustment = -loopWidth;
            }

            if (!adjustment) return false;

            track.classList.add('is-loop-jumping');
            track.scrollLeft += adjustment;
            window.requestAnimationFrame(() => {
              track.classList.remove('is-loop-jumping');
            });
            return true;
          }

          function scheduleLoopNormalization() {
            if (!infiniteEnabled) return;

            window.clearTimeout(loopNormalizeTimer);
            loopNormalizeTimer = window.setTimeout(() => {
              normalizeLoopPosition();
            }, 140);
          }

          function getSnapPoints() {
            const trackBounds = track.getBoundingClientRect();

            return Array.from(track.querySelectorAll('.eg-pdp-gardener-videos__card')).map((card) => {
              const cardBounds = card.getBoundingClientRect();
              return clampScroll(cardBounds.left - trackBounds.left + track.scrollLeft);
            });
          }

          function getNearestSnap(value) {
            const points = getSnapPoints();
            if (!points.length) return clampScroll(value);

            return points.reduce((closest, point) => (
              Math.abs(point - value) < Math.abs(closest - value) ? point : closest
            ));
          }

          function stopScrollAnimation() {
            if (scrollAnimationFrame !== null) {
              window.cancelAnimationFrame(scrollAnimationFrame);
              scrollAnimationFrame = null;
            }

            track.classList.remove('is-settling');
          }

          function animateScrollTo(value) {
            stopScrollAnimation();

            const start = track.scrollLeft;
            const target = clampScroll(value);
            const distance = target - start;

            if (reduceMotion.matches || Math.abs(distance) < 1) {
              track.scrollLeft = target;
              normalizeLoopPosition();
              updateControls();
              return;
            }

            const duration = Math.min(520, Math.max(320, Math.abs(distance) * 0.85));
            const startedAt = window.performance.now();

            track.classList.add('is-settling');

            const tick = (now) => {
              const progress = Math.min(1, (now - startedAt) / duration);
              const eased = 1 - Math.pow(1 - progress, 4);

              track.scrollLeft = start + distance * eased;

              if (progress < 1) {
                scrollAnimationFrame = window.requestAnimationFrame(tick);
                return;
              }

              scrollAnimationFrame = null;
              track.classList.remove('is-settling');
              normalizeLoopPosition();
              updateControls();
            };

            scrollAnimationFrame = window.requestAnimationFrame(tick);
          }

          function updateControls() {
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
            const currentScroll = Math.max(0, track.scrollLeft);
            const canScroll = maxScroll > 6;

            section.dataset.canScroll = canScroll ? 'true' : 'false';

            if (infiniteEnabled && canScroll) {
              section.dataset.scrollState = 'middle';
              prevButtons.forEach((button) => {
                button.disabled = false;
              });
              nextButtons.forEach((button) => {
                button.disabled = false;
              });
              return;
            }

            if (!canScroll) {
              section.dataset.scrollState = 'none';
            } else if (currentScroll <= 2) {
              section.dataset.scrollState = 'start';
            } else if (currentScroll >= maxScroll) {
              section.dataset.scrollState = 'end';
            } else {
              section.dataset.scrollState = 'middle';
            }

            prevButtons.forEach((button) => {
              button.disabled = !canScroll || currentScroll <= 2;
            });

            nextButtons.forEach((button) => {
              button.disabled = !canScroll || currentScroll >= maxScroll;
            });
          }

          function scrollByStep(direction) {
            const target = track.scrollLeft + direction * getScrollStep();
            animateScrollTo(getNearestSnap(target));
          }

          function startDrag(event) {
            if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0) {
              return;
            }

            stopScrollAnimation();
            dragPointerId = event.pointerId;
            dragStartX = event.clientX;
            dragStartScrollLeft = track.scrollLeft;
            dragLastTime = window.performance.now();
            dragVelocity = 0;
            dragMoved = false;
          }

          function moveDrag(event) {
            if (event.pointerId !== dragPointerId) {
              return;
            }

            const distance = event.clientX - dragStartX;
            if (!dragMoved && Math.abs(distance) < 6) {
              return;
            }

            if (!dragMoved) {
              dragMoved = true;
              track.setPointerCapture?.(event.pointerId);
              track.classList.add('is-dragging');
              previewTriggers.forEach((trigger) => stopPreview(trigger));
            }

            event.preventDefault();
            const now = window.performance.now();
            const nextScroll = clampScroll(dragStartScrollLeft - distance);
            const elapsed = Math.max(1, now - dragLastTime);
            const instantVelocity = (nextScroll - track.scrollLeft) / elapsed;

            dragVelocity = dragVelocity * 0.65 + instantVelocity * 0.35;
            dragLastTime = now;
            track.scrollLeft = nextScroll;
          }

          function finishDrag(event) {
            if (event.pointerId !== dragPointerId) {
              return;
            }

            if (track.hasPointerCapture?.(dragPointerId)) {
              track.releasePointerCapture(dragPointerId);
            }

            const wasDragged = dragMoved;

            if (wasDragged) {
              suppressClickUntil = window.performance.now() + 350;
            }

            dragPointerId = null;
            dragMoved = false;
            track.classList.remove('is-dragging');

            if (wasDragged) {
              const maxMomentum = getScrollStep() * 1.25;
              const momentum = Math.max(-maxMomentum, Math.min(maxMomentum, dragVelocity * 180));
              const projected = track.scrollLeft + momentum;
              animateScrollTo(getNearestSnap(projected));
            } else {
              scheduleLoopNormalization();
              updateControls();
            }
          }

          function suppressClickAfterDrag(event) {
            if (window.performance.now() >= suppressClickUntil) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();
          }

          function updateModalButtons() {
            const total = playableTriggers.length;
            const disabled = total < 2;

            if (modalPrev) {
              modalPrev.disabled = disabled;
            }

            if (modalNext) {
              modalNext.disabled = disabled;
            }
          }

          function autoplayModalVideo() {
            const video = stage?.querySelector('.eg-pdp-gardener-videos__modal-video');
            if (!video) {
              return;
            }

            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            video.preload = 'auto';

            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {
                // Native controls remain available when a mobile browser declines autoplay.
              });
            }
          }

          function renderModal(index) {
            if (!stage || !templates.size) {
              return;
            }

            const total = playableTriggers.length;
            if (!total) {
              return;
            }

            modalIndex = (index + total) % total;

            const template = templates.get(modalIndex);
            stage.replaceChildren();

            if (template) {
              stage.appendChild(template.content.cloneNode(true));
              autoplayModalVideo();
            }

            updateModalButtons();
          }

          function openModal(index, focusTarget) {
            if (!modal || !stage || !playableTriggers.length) {
              return;
            }

            window.clearTimeout(closeTimer);
            modal.classList.remove('is-closing');
            lastFocus = focusTarget || document.activeElement;
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('eg-pdp-gardener-videos-modal-open');
            renderModal(index);

            if (closeButton) {
              closeButton.focus();
            }
          }

          function closeModal() {
            if (!modal || !stage || !modal.classList.contains('is-open')) {
              return;
            }

            modal.classList.remove('is-open');
            modal.classList.add('is-closing');
            modal.setAttribute('aria-hidden', 'true');
            window.clearTimeout(closeTimer);
            closeTimer = window.setTimeout(() => {
              modal.classList.remove('is-closing');
              stage.replaceChildren();
              document.body.classList.remove('eg-pdp-gardener-videos-modal-open');

              if (lastFocus && typeof lastFocus.focus === 'function') {
                lastFocus.focus();
              }

              lastFocus = null;
            }, reduceMotion.matches ? 100 : 200);
          }

          function handleKeydown(event) {
            if (!modal || !modal.classList.contains('is-open')) {
              return;
            }

            if (event.key === 'Escape') {
              event.preventDefault();
              closeModal();
            } else if (event.key === 'ArrowLeft' && playableTriggers.length > 1) {
              event.preventDefault();
              renderModal(modalIndex - 1);
            } else if (event.key === 'ArrowRight' && playableTriggers.length > 1) {
              event.preventDefault();
              renderModal(modalIndex + 1);
            }
          }

          prevButtons.forEach((button) => {
            button.addEventListener('click', () => {
              scrollByStep(-1);
            }, { signal });
          });

          nextButtons.forEach((button) => {
            button.addEventListener('click', () => {
              scrollByStep(1);
            }, { signal });
          });

          playableTriggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
              stopPreview(trigger);
              openModal(Number(trigger.dataset.videoIndex), trigger);
            }, { signal });
          });

          previewTriggers.forEach((trigger) => {
            if (trigger.querySelector('.eg-pdp-gardener-videos__preview-video')) {
              trigger.addEventListener('pointerenter', () => startPreview(trigger), { signal });
              trigger.addEventListener('pointerleave', () => stopPreview(trigger), { signal });
              trigger.addEventListener('blur', () => stopPreview(trigger), { signal });
            }
          });

          track.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-gardener-video-trigger]');
            const cloneCard = trigger?.closest('[data-gardener-video-clone]');

            if (!trigger || !cloneCard || trigger.disabled) {
              return;
            }

            const videoIndex = Number(trigger.dataset.videoIndex);
            const originalTrigger = playableTriggers.find(
              (playableTrigger) => Number(playableTrigger.dataset.videoIndex) === videoIndex
            );

            stopPreview(trigger);
            openModal(videoIndex, originalTrigger);
          }, { signal });

          if (closeButton) {
            closeButton.addEventListener('click', closeModal, { signal });
          }

          if (overlay) {
            overlay.addEventListener('click', closeModal, { signal });
          }

          if (modal) {
            modal.addEventListener('click', (event) => {
              if (event.target === modal) {
                closeModal();
              }
            }, { signal });
          }

          if (modalPrev) {
            modalPrev.addEventListener('click', () => {
              renderModal(modalIndex - 1);
            }, { signal });
          }

          if (modalNext) {
            modalNext.addEventListener('click', () => {
              renderModal(modalIndex + 1);
            }, { signal });
          }

          track.addEventListener('scroll', () => {
            updateControls();
            scheduleLoopNormalization();
          }, { passive: true, signal });
          track.addEventListener('pointerdown', startDrag, { signal });
          track.addEventListener('lostpointercapture', finishDrag, { signal });
          track.addEventListener('click', suppressClickAfterDrag, { capture: true, signal });
          track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
          document.addEventListener('pointermove', moveDrag, { signal });
          document.addEventListener('pointerup', finishDrag, { signal });
          document.addEventListener('pointercancel', finishDrag, { signal });
          window.addEventListener('resize', updateControls, { signal });
          document.addEventListener('keydown', handleKeydown, { signal });
          reduceMotion.addEventListener('change', () => {
            if (reduceMotion.matches) stopScrollAnimation();
          }, { signal });

          track.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', () => {
              updateLoopMetrics();
              scheduleLoopNormalization();
              updateControls();
            }, { signal });
          });

          resizeObserver?.observe(track);

          signal.addEventListener('abort', () => {
            window.clearTimeout(loopNormalizeTimer);
            stopScrollAnimation();
            resizeObserver?.disconnect();
            track.classList.remove('is-dragging');
            previewTriggers.forEach((trigger) => stopPreview(trigger));
            previewVideos.forEach((video) => video.pause());
          }, { once: true });

          document.addEventListener('shopify:block:select', (event) => {
            const block = event.target.closest('.eg-pdp-gardener-videos__card');

            if (!block || !section.contains(block)) {
              return;
            }

            block.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });

            window.setTimeout(updateControls, 220);
          }, { signal });

          initializeLoop();
          updateControls();
          window.setTimeout(updateControls, 180);
        });
      }
    };

    document.addEventListener('shopify:section:load', (event) => {
      window.EgPdpGardenerVideos.init(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-eg-pdp-gardener-videos]');

      if (!section || !section.__egGardenerVideosController) {
        return;
      }

      section.__egGardenerVideosController.abort();
      if (section.__egGardenerVideosModal && section.__egGardenerVideosModal.parentElement) {
        section.__egGardenerVideosModal.remove();
      }
      delete section.__egGardenerVideosController;
      delete section.__egGardenerVideosModal;
      delete section.dataset.gardenerVideosReady;
      document.body.classList.remove('eg-pdp-gardener-videos-modal-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.EgPdpGardenerVideos.init(document);
    }, { once: true });
  } else {
    window.EgPdpGardenerVideos.init(document);
  }
})();
